import { Injectable } from "@angular/core";

@Injectable()
export class CommonLoaderService {
  constructor() {}

  configure = (): void => {};
}
